import React from 'react';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { priceInCentsToStrWithSymbol, applyDiscountOnPrice } from '@/utils/priceCalc';

const PricingSaving = ({ product , minPriceInCents, editMode , discountPercentage}) => {
  const theme = useTheme();

  if (!product || editMode) {
    return null;
  }

  const rows = [];
  const addRow = (header, value , strike) => {
    rows.push(
      <tr key={header}>
        <td style={{ padding: '', verticalAlign: 'top' }}>
          <Typography variant="caption" >
            {header}
          </Typography>
        </td>
        <td style={{ padding: '0px 0px 0px 10px', whiteSpace: 'pre-line' }}>
          <Typography
            component={strike ? 's' : 'span'}
            sx={{ fontWeight: !strike && 700 }}
            color={strike ? 'text.secondary' : theme.palette.primary.main}
          >
            {value}
          </Typography>
        </td>
      </tr>,
    );
  };

  const productPrice = minPriceInCents ? minPriceInCents : product.purchaseInfo?.price_cents;
  const retailPrice = product.purchaseInfo?.retail_price_cents
  // const bestPriceInMarket = product.bestPriceInMarket && parseInt(product.bestPriceInMarket);
  if (retailPrice && retailPrice > productPrice) {
    addRow(
      'Retail price',
      priceInCentsToStrWithSymbol(retailPrice),
      true,
    );
  }
  // if (product.bestPriceInMarket && bestPriceInMarket > productPrice) {
  //   addRow(
  //     'Best price in market in cents',
  //     priceInCentsToStrWithSymbol(product.bestPriceInMarket),
  //     true,
  //   );
  // }

  let save = 0;

  if (product.retailPrice) {
    save = save + parseInt(product.retailPrice - product.ourPrice);
  } else if (product.bestPriceInMarket) {
    save = save + parseInt(product.bestPriceInMarket - product.ourPrice);
  }

  if (discountPercentage) {
    addRow('Our price before discount', priceInCentsToStrWithSymbol(product.ourPrice), true);
    save = save + (product.ourPrice - applyDiscountOnPrice(product.ourPrice, discountPercentage));
  }

  if (save) {
    addRow('You save in cents', priceInCentsToStrWithSymbol(save));
  }

  return (
    <table style={{margin: '0 auto'}}>
      <tbody>
        {rows}
      </tbody>
    </table>
  );
};

PricingSaving.propTypes = {
  product: PropTypes.object,
  minPriceInCents: PropTypes.number,
  editMode: PropTypes.bool,
  discountPercentage: PropTypes.number
};

export default PricingSaving;
